import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-logo">
          <img src="https://preciseca.com/wp-content/uploads/2025/12/precisecaLogo.png" alt="PreciseCA" />
        </a>
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <li><a href="#home">Precise CA</a></li>
          <li><a href="#features">Features</a></li>
          <li><a href="#version-pricing">Pricing</a></li>
          <li><a href="#about">About Us</a></li>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="https://partner.preciseca.io/login" className="btn-outline">Partner Login</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
